import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
  useToast,
  Image,
} from '@chakra-ui/react';
import DefaultAuth from 'layouts/auth/Default';
import illustration from 'assets/img/auth/cediiap-3.jpg';
import logo from 'assets/img/auth/auth.png';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import { useAuth } from '../../../contexts/AuthContext';
import { postData } from '../../../utils/httpClient';
import { getDefaultRoute, setUserAuthData } from '../../../utils/roleAccess';

function SignIn() {
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const brandStars = useColorModeValue('brand.500', 'brand.400');

  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const toast = useToast();

  useEffect(() => {
    // Mostrar toast si sesión expiró
    if (sessionStorage.getItem('sessionExpired')) {
      toast({
        title: 'Sesión expirada',
        description: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      sessionStorage.removeItem('sessionExpired');
    }
  }, [toast]);


  const handleClick = () => setShow(!show);

  const handleLogin = async () => {
    try {
      const loginUser = {
        user: user,
        password: password,
      };

      const response = await postData('/auth/login', loginUser);

      if (response.status === 200) {
        const payload = response?.payload || {};
        login({
          roles: payload.roles || [],
          accesses: payload.accesses || [],
          userId: payload.userId,
          username: payload.username,
        });
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('token', payload.token);
        localStorage.setItem('refreshToken', payload.refreshToken);
        setUserAuthData({
          roles: payload.roles || [],
          accesses: payload.accesses || [],
        });

        navigate(getDefaultRoute(payload.roles || [], payload.accesses || []));
      }
    } catch (error) {
      console.log(error);
      toast({
        title: 'Usuario o contraseña incorrectos',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex
        maxW={{ base: '100%', md: 'max-content' }}
        w="100%"
        mx={{ base: 'auto', lg: '0px' }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: '30px', md: '60px' }}
        px={{ base: '25px', md: '0px' }}
        mt={{ base: '40px', md: '14vh' }}
        flexDirection="column"
      >
        <Image
            src={logo}
            alt="Logo"
            h={{base: '80px', md:'120px'}}
            mb="50px"
            mx="auto"
            display={{ base: 'block', xl: 'none' }}
          />
        <Box me="auto">
          {/* <Image src={logo} alt="Logo" boxSize="50px" mb="10px" display={{ base: "block", xl: "none" }} /> */}
          <Heading color={textColor} fontSize="36px" mb="10px">
            Bienvenido
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Ingresar usuario y contraseña para ingresar
          </Text>
        </Box>
        <Flex
          as="form"
          onSubmit={(e) => {
            e.preventDefault();
            handleLogin();
          }}
          zIndex="2"
          direction="column"
          w={{ base: '100%', md: '420px' }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: 'auto', lg: 'unset' }}
          me="auto"
          mb={{ base: '20px', md: 'auto' }}
        >
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Usuario<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired
              variant="auth"
              fontSize="sm"
              type="text"
              placeholder="Ingresar usuario"
              mb="24px"
              fontWeight="500"
              size="lg"
              value={user}
              onChange={(e) => setUser(e.target.value)}
            />
            <FormLabel
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              display="flex"
            >
              Contraseña<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size="md">
              <Input
                isRequired
                fontSize="sm"
                placeholder="Ingresar contraseña"
                mb="24px"
                size="lg"
                type={show ? 'text' : 'password'}
                variant="auth"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement display="flex" alignItems="center" mt="4px">
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: 'pointer' }}
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={handleClick}
                />
              </InputRightElement>
            </InputGroup>
            <Button
              type="submit"
              fontSize="sm"
              variant="brand"
              fontWeight="500"
              w="100%"
              h="50"
              mb="24px"
              sx={{
                backgroundColor: '#003064',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#00a4de',
                },
              }}
            >
              Iniciar sesión
            </Button>
          </FormControl>
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
